var map = {
	"./ass.js": 2678,
	"./json.js": 2679,
	"./lrc.js": 2680,
	"./sbv.js": 2681,
	"./smi.js": 2682,
	"./srt.js": 2683,
	"./ssa.js": 1257,
	"./sub.js": 2684,
	"./vtt.js": 2685
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2677;


//////////////////
// WEBPACK FOOTER
// ./~/subsrt/lib/format ^\.\/.*\.js$
// module id = 2677
// module chunks = 0